export enum ListPaneType {
  Grid = 'grid',
  Floor = 'floor'
}
